<!-- 由 suu 创建于 2022-01-19 星期三 -->
<template>
  <div class="result-tab">
    <div class="tab-region">
      <div
        class="t-item"
        :class="{ 't-item-ac': curTab == index }"
        @click="handelChange(index)"
        v-for="(item, index) in tabs"
        :key="index"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'result-tab',

  components: {},

  props: {
    tabs: {},
    activeTab: {}
  },

  data() {
    return {
      curTab: 0
    }
  },

  computed: {},

  watch: {},

  created() {
    this.curTab = this.activeTab
  },

  mounted() {},

  destroyed() {},

  methods: {
    handelChange(i) {
      this.curTab = i
      this.$emit('tabclick', i)
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 750) * 100vw;
}
.result-tab {
  width: 100%;
  box-sizing: border-box;
  overflow: auto;
  .tab-region {
    width: max-content;
    display: flex;
    align-items: center;
    .t-item {
      margin-right: vw(48);
      font-size: vw(26);
      color: #979da5;
    }
    .t-item-ac {
      font-size: vw(40);
      color: #fa5a73;
      font-weight: 600;
    }
  }
}
</style>
